function imgSetSrc($el) {
  $el.each(function(){
    let $self = $(this)

    if (!$self.attr('src') && $self.attr('data-src')) {
      let dataSrc = $self.attr('data-src')
      $self.attr('src', '')// there for visual purpose in inspector
      $self.attr('src', dataSrc)
      $self.removeAttr('data-src')
    }
    if (!$self.attr('srcset') && $self.attr('data-srcset')) {
      let dataSrcset = $self.attr('data-srcset')
      $self.attr('data-srcset', '')// there for visual purpose in inspector
      $self.attr('srcset', dataSrcset)
      $self.removeAttr('data-srcset')
    }

  })
}

export default imgSetSrc